export type SingleUsageLogo = {
	usageLogo: string;
	usageTextId: string;
};

const model: types.models.InputModel = {
	usageLogo: 'UsageLogo',
	usageTextId: 'UsageTextId',
};

export default model;
